import headerTemplate from './templates/header';
import footerTemplate from './templates/footer';
import headerMobileTemplate from './templates/headerMobile';
import jobsSingleTemplate from './templates/jobsSingle';

export default function templates() {
    headerTemplate();
    headerMobileTemplate();
    footerTemplate();
    jobsSingleTemplate();
}